var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("datepicker-wrapper-custom " + _vm.cssClass)},[_c('input',{attrs:{"id":"calendar-datepicker"}})])}
var staticRenderFns = []

export { render, staticRenderFns }